// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BorrowedBooksPage Styles */

.borrowed-books-page {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 2rem;
  gap: 2rem;
}

.page-header-section {
  text-align: center;
}

.page-header-section h1 {
  font-size: 2rem;
  font-weight: 800;
  color: var(--text-main);
  margin-bottom: 0.5rem;
}

.page-header-section p {
  font-size: 1rem;
  color: var(--text-sub);
  margin: 0;
}

.filter-section {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.search-wrapper {
  position: relative;
  flex: 1 1;
  min-width: 200px;
}

.search-wrapper .material-symbols-outlined {
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-sub);
  font-size: 20px;
}

.search-wrapper .form-input {
  width: 100%;
  padding: 0.625rem 0.75rem 0.625rem 2.5rem;
  border: 1px solid var(--slate-200);
  border-radius: var(--radius-lg);
  font-size: 0.875rem;
  background-color: var(--surface-light);
}

.search-wrapper .form-input:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 2px var(--primary-light);
}

.category-select {
  width: 200px;
  padding: 0.625rem 0.75rem;
  border: 1px solid var(--slate-200);
  border-radius: var(--radius-lg);
  font-size: 0.875rem;
  background-color: var(--surface-light);
  cursor: pointer;
}

.category-select:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 2px var(--primary-light);
}

.books-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
}

@media (min-width: 640px) {
  .books-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (min-width: 768px) {
  .books-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (min-width: 1024px) {
  .books-grid {
    grid-template-columns: repeat(5, 1fr);
  }
}

.total-count {
  text-align: center;
  padding: 1rem;
  color: var(--text-sub);
  font-size: 0.875rem;
  border-top: 1px solid var(--slate-200);
}

.total-count strong {
  color: var(--text-main);
  font-weight: 600;
}

.total-count-top {
  background-color: var(--surface-light);
  border-radius: var(--radius-lg);
  margin-bottom: 1.5rem;
  border: 1px solid var(--slate-200);
  box-shadow: var(--shadow-sm);
}

.available-count {
  color: var(--success-text);
  font-weight: 600;
}

.borrowed-count {
  color: var(--borrowed-text);
  font-weight: 600;
}

/* Responsive */
@media (max-width: 768px) {
  .borrowed-books-page {
    padding: 1rem;
  }

  .page-header-section h1 {
    font-size: 1.5rem;
  }

  .filter-section {
    flex-direction: column;
  }

  .category-select {
    width: 100%;
  }

  .books-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/BorrowedBooksPage.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yCAAyC;EACzC,kCAAkC;EAClC,+BAA+B;EAC/B,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kCAAkC;EAClC,+BAA+B;EAC/B,mBAAmB;EACnB,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,+BAA+B;EAC/B,qBAAqB;EACrB,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;AACF","sourcesContent":["/* BorrowedBooksPage Styles */\n\n.borrowed-books-page {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 2rem;\n  gap: 2rem;\n}\n\n.page-header-section {\n  text-align: center;\n}\n\n.page-header-section h1 {\n  font-size: 2rem;\n  font-weight: 800;\n  color: var(--text-main);\n  margin-bottom: 0.5rem;\n}\n\n.page-header-section p {\n  font-size: 1rem;\n  color: var(--text-sub);\n  margin: 0;\n}\n\n.filter-section {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.search-wrapper {\n  position: relative;\n  flex: 1;\n  min-width: 200px;\n}\n\n.search-wrapper .material-symbols-outlined {\n  position: absolute;\n  left: 0.75rem;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--text-sub);\n  font-size: 20px;\n}\n\n.search-wrapper .form-input {\n  width: 100%;\n  padding: 0.625rem 0.75rem 0.625rem 2.5rem;\n  border: 1px solid var(--slate-200);\n  border-radius: var(--radius-lg);\n  font-size: 0.875rem;\n  background-color: var(--surface-light);\n}\n\n.search-wrapper .form-input:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 2px var(--primary-light);\n}\n\n.category-select {\n  width: 200px;\n  padding: 0.625rem 0.75rem;\n  border: 1px solid var(--slate-200);\n  border-radius: var(--radius-lg);\n  font-size: 0.875rem;\n  background-color: var(--surface-light);\n  cursor: pointer;\n}\n\n.category-select:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 2px var(--primary-light);\n}\n\n.books-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1.5rem;\n}\n\n@media (min-width: 640px) {\n  .books-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (min-width: 768px) {\n  .books-grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n@media (min-width: 1024px) {\n  .books-grid {\n    grid-template-columns: repeat(5, 1fr);\n  }\n}\n\n.total-count {\n  text-align: center;\n  padding: 1rem;\n  color: var(--text-sub);\n  font-size: 0.875rem;\n  border-top: 1px solid var(--slate-200);\n}\n\n.total-count strong {\n  color: var(--text-main);\n  font-weight: 600;\n}\n\n.total-count-top {\n  background-color: var(--surface-light);\n  border-radius: var(--radius-lg);\n  margin-bottom: 1.5rem;\n  border: 1px solid var(--slate-200);\n  box-shadow: var(--shadow-sm);\n}\n\n.available-count {\n  color: var(--success-text);\n  font-weight: 600;\n}\n\n.borrowed-count {\n  color: var(--borrowed-text);\n  font-weight: 600;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .borrowed-books-page {\n    padding: 1rem;\n  }\n\n  .page-header-section h1 {\n    font-size: 1.5rem;\n  }\n\n  .filter-section {\n    flex-direction: column;\n  }\n\n  .category-select {\n    width: 100%;\n  }\n\n  .books-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
